import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../utils/api';

const BranchContext = createContext();

export const useBranch = () => {
  const context = useContext(BranchContext);
  if (!context) {
    throw new Error('useBranch must be used within BranchProvider');
  }
  return context;
};

export const BranchProvider = ({ children, user }) => {
  const [branches, setBranches] = useState([]);
  const [activeBranch, setActiveBranch] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Only fetch branches if user is authenticated
    if (user) {
      fetchBranches();
    } else {
      setLoading(false);
      setBranches([]);
      setActiveBranch(null);
    }
  }, [user]);

  const fetchBranches = async () => {
    try {
      const response = await api.get('/branches');
      setBranches(response.data || []);
      
      // Set active branch from localStorage or first branch
      const savedBranchId = localStorage.getItem('activeBranchId');
      if (savedBranchId && response.data.find(b => b.branch_id === savedBranchId)) {
        setActiveBranch(response.data.find(b => b.branch_id === savedBranchId));
      } else if (response.data.length > 0) {
        setActiveBranch(response.data[0]);
        localStorage.setItem('activeBranchId', response.data[0].branch_id);
      }
    } catch (error) {
      console.error('Failed to fetch branches:', error);
    } finally {
      setLoading(false);
    }
  };

  const switchBranch = (branch) => {
    setActiveBranch(branch);
    localStorage.setItem('activeBranchId', branch.branch_id);
    // Trigger a page reload to refresh all data
    window.location.reload();
  };

  return (
    <BranchContext.Provider
      value={{
        branches,
        activeBranch,
        switchBranch,
        loading,
        refreshBranches: fetchBranches
      }}
    >
      {children}
    </BranchContext.Provider>
  );
};
